module.exports = __webpack_public_path__ + "static/logo-fc433810690906799bee1d2ef07a6ab8.png";